import {
  Box,
  Button,
  Container,
  Image,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
// import ScreenShot from "common/assets/img/screenshot.png";
import ScreenShot from "common/assets/img/dashDummy2.png"
import NewDashImg from "common/assets/img/dashDummy2.png"
import PlayButton from "common/assets/img/playButton.png";
import ArrowRight from "common/assets/img/arrowRightWhite.png";
import PlayIcon from "common/assets/img/playIconStroke.png";
import HeroTextureBg from "common/assets/img/heroTextureBg.png";
import dashVideo from "common/assets/video/daashboardVideo.mp4";
import { landingPageConstants } from "common/landingPageConstants";

const HeroSection = ({ handleNavigate }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const onPreview = () => {
    onOpen();
  };
  return (
    <>
      <Container maxW="full">
        <Box className="heroSection">
          <Container maxW="container.xl">
            <Box className="heroMain">
              <Image src={HeroTextureBg} height={"auto"} width={"100%"} className="heroTextureBg" alt=""/>
              <Box className="heroContent">
                <Text className="heroTitle">
                  {landingPageConstants.manage} <span className="ctaColor">
                    {landingPageConstants.heroTitlectaColor} </span>
{landingPageConstants.heroTitle}</Text>
                <Text className="heroDesc">
                  {landingPageConstants.heroDesc}
                </Text>
                <Box className="heroActions">
                  <Link href="/#/createWorkspace">
                    <Button
                      colorScheme="brand"
                      className="customButton"
                    >
                      {landingPageConstants.getStarted}
                      <Image
                        src={ArrowRight}
                        height="24px"
                        width="24px"
                        marginLeft="8px"
                        alt="" 
                        />
                    </Button>
                  </Link>
                  <Link href="#video">
                    <Button
                      colorScheme="brand"
                      className="customButton outlined"
                    >
                       <Image
                        src={PlayIcon}
                        height="24px"
                        width="24px"
                        marginRight="8px"
                        alt="" 
                        />
                      {landingPageConstants.watchDemo}                     
                    </Button>
                  </Link>
                </Box>
              </Box>
              <Box className="videoSection">
                <Image
                  src={NewDashImg}
                  height="614px"
                  borderRadius="20px"
                  width="100%"
                  alt=""
                  className="heroImage"
                />                
              </Box>
            </Box>
          </Container>
        </Box>
      </Container>
      <Modal onClose={onClose} size={"full"} isOpen={isOpen} className>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton fontSize={"20px"} />
          <ModalBody display={"flex"} justifyContent={"center"}>
            <video
              className="videoModal"
              controls
              loop
              disablePictureInPicture
              controlsList="nofullscreen"
            >
              <source src={dashVideo} />
            </video>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default HeroSection;
